import React, {useState} from 'react';
import './GenerateComedy.css';
import DefaultComedy from './DefaultComedy';
import CustomComedy from './CustomComedy';

function GenerateComedy() {
    const [defaultOrAll, setdefaultOrAll] = useState(true);
    const [intigerValue, setIntigerValue] = useState(0); // tylko po to, zeby przy zmianie sie rerenderowal komponent, takie odswiezanie
                                                         // inna opcja to by bylo history.push('/'), ale wtedy nie zapisuje sie stan defaultOrAll, czyl
                                                         // przy kazdym przeladowaniu strony by dawalo domyslne opcje
    return (
        <div>
            <div className="scenariuszILink">
                <div className="scenariusz">
                    <span className="przerwa">
                        <div className="onOffStatus"> 
                        {!defaultOrAll===true && <p>z pomyslami innych</p>}
                        {defaultOrAll===true && <p>bez innych</p>}
                        </div>
                    </span>
                    <div className="relativeClass"></div>
                    {
                        (defaultOrAll === true) 
                        ? (  <DefaultComedy/> )
                        : (  <CustomComedy/> )
                    }
                </div>
                <div className="przyciski">
                    <button className="losulosu" onClick={ () => setIntigerValue(intigerValue + 1)} > Wylosuj </button> 
                    <button className="losulosu" onClick={() => setdefaultOrAll(!defaultOrAll)}>Wlacz pomysly innych</button>
                </div>
  
        </div>
      
      </div>
    )
}

export default GenerateComedy;
